export default __webpack_public_path__ + "favicon-32x32.0a2dcc4bc3d372635f52acca06205b18.png";